import React from "react";
import { HERO, IMAGES } from "../mock";

const Hero = () => {
  return (
    <section
      id="about"
      className="relative"
      style={{ background: "#0d1b2e", paddingTop: 92 }}
    >
      {/* right side steel image */}
      <div
        className="absolute top-0 right-0 h-full hidden md:block"
        style={{
          width: "52%",
          backgroundImage: `url(${IMAGES.heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "grayscale(30%)",
        }}
      >
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(90deg, #0d1b2e 0%, rgba(13,27,46,0.85) 22%, rgba(13,27,46,0.35) 70%, rgba(13,27,46,0.55) 100%)",
          }}
        />
      </div>

      <div className="si-container relative" style={{ zIndex: 2 }}>
        <div className="max-w-2xl" style={{ paddingTop: 96, paddingBottom: 110 }}>
          <h1
            className="text-white font-bold"
            style={{ fontSize: "clamp(40px, 6vw, 68px)", lineHeight: 1.02 }}
          >
            {HERO.title[0]}
            <br />
            {HERO.title[1]}
          </h1>

          <div className="mt-8 space-y-5 max-w-xl">
            {HERO.paragraphs.map((p, i) => (
              <p
                key={i}
                style={{ color: "#c3cdda", fontSize: 17, lineHeight: 1.65 }}
              >
                {p}
              </p>
            ))}
          </div>

          <div className="mt-9 flex flex-wrap gap-4">
            <a href={HERO.primaryCta.href} className="btn-primary">
              {HERO.primaryCta.label}
            </a>
            <a href={HERO.secondaryCta.href} className="btn-outline-light">
              {HERO.secondaryCta.label}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
